var infraestructuras = angular.module('infraestructuras');

infraestructuras.controller('infraestructurasADIFController', ['$rootScope', '$scope', '$location', 'infraestructurasService', 'inspeccionesService', '$routeParams', 'authenticationInfo', 'authenticationService', '$sce', '$timeout', '$http',

    function ($rootScope, $scope, $location, infraestructurasService, inspeccionesService, $routeParams, authenticationInfo, authenticationService, $sce, $timeout, $http
    ) {

        $scope.authentication = authenticationInfo;


        $rootScope.categoria = $routeParams.id;

        $scope.pestanyamenusuperior = 'redtuneles';

        $scope.redtunelesCargar = function () {
            $scope.pestanyamenusuperior = 'redtuneles';
            // mostrarCapaViasADIF(false);
        };

        $scope.filtroGravedadTexto = '';


        $scope.paginaPatologias = 1;
        $scope.tamanoPaginaPatologias = 100;
        $scope.totalPatologiasModal = 0;
        $scope.totalPaginasPatologias = 1;



        $scope.patologiasSeleccionadas = [];
        $scope.gravedadPatologiasSeleccionada = null;
        $scope.cargandoPatologias = false;
        function normalizarTexto(valor) {
            return String(valor || '')
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }

        function convertirCoordenadaGIS(valor) {

            if (
                valor === null ||
                valor === undefined ||
                valor === ''
            ) {
                return null;
            }

            var numero = Number(
                String(valor).replace(',', '.')
            );

            return isNaN(numero)
                ? null
                : numero;
        }


        $scope.abrirSelectorFiltro = function (filtro) {

            $scope.mostrarSelectorTipoRed =
                filtro === 'tipored';

            $scope.mostrarSelectorJefatura =
                filtro === 'jefatura';

            $scope.mostrarSelectorTuneles =
                filtro === 'tunel';

            $scope.mostrarSelectorDenominacion =
                filtro === 'denominacion';

            $scope.mostrarSelectorGravedad =
                filtro === 'gravedad';
        };


        $scope.textoPlaceholderMultiple =
            function (
                seleccionados,
                placeholder,
                textoPlural
            ) {

                seleccionados =
                    angular.isArray(seleccionados)
                        ? seleccionados
                        : [];

                if (seleccionados.length === 0) {
                    return placeholder;
                }

                if (seleccionados.length === 1) {
                    return seleccionados[0];
                }

                return (
                    seleccionados.length +
                    ' ' +
                    textoPlural
                );
            };


        $scope.textoPlaceholderTipoRed = function () {

            var seleccionados =
                $scope.filtrosTuneles.TipoRedId || [];

            if (seleccionados.length === 0) {
                return 'Escriba un tipo de red';
            }

            if (seleccionados.length > 1) {
                return (
                    seleccionados.length +
                    ' tipos de red seleccionados'
                );
            }

            var id =
                Number(seleccionados[0]);

            var tipo =
                ($scope.catalogoTiposRed || [])
                    .find(function (elemento) {

                        return (
                            Number(elemento.Id) === id
                        );
                    });

            return tipo
                ? tipo.Descripcion
                : '';
        };



        function alternarValorFiltro(
            lista,
            valor,
            compararNumerico
        ) {

            var indice = -1;

            for (var i = 0; i < lista.length; i++) {

                var iguales =
                    compararNumerico
                        ? Number(lista[i]) === Number(valor)
                        : lista[i] === valor;

                if (iguales) {
                    indice = i;
                    break;
                }
            }


            if (indice === -1) {

                lista.push(valor);

            } else {

                lista.splice(indice, 1);
            }
        }


        function valorFiltroSeleccionado(
            lista,
            valor,
            compararNumerico
        ) {

            if (!angular.isArray(lista)) {
                return false;
            }

            return lista.some(function (seleccionado) {

                return compararNumerico
                    ? Number(seleccionado) === Number(valor)
                    : seleccionado === valor;
            });
        }


        /* ==========================================
           TIPO DE RED
           ========================================== */

        $scope.tipoRedFiltroSeleccionado =
            function (id) {

                return valorFiltroSeleccionado(
                    $scope.filtrosTuneles.TipoRedId,
                    id,
                    true
                );
            };


        $scope.alternarTipoRedFiltro =
            function (id) {

                alternarValorFiltro(
                    $scope.filtrosTuneles.TipoRedId,
                    id,
                    true
                );
            };


        /* ==========================================
           JEFATURA
           ========================================== */

        $scope.jefaturaFiltroSeleccionada =
            function (jefatura) {

                return valorFiltroSeleccionado(
                    $scope.filtrosTuneles.Jefatura,
                    jefatura,
                    false
                );
            };


        $scope.alternarJefaturaFiltro =
            function (jefatura) {

                alternarValorFiltro(
                    $scope.filtrosTuneles.Jefatura,
                    jefatura,
                    false
                );
            };


        /* ==========================================
           DENOMINACIÓN
           ========================================== */

        $scope.denominacionFiltroSeleccionada =
            function (denominacion) {

                return valorFiltroSeleccionado(
                    $scope.filtrosTuneles.Denominacion,
                    denominacion,
                    false
                );
            };


        $scope.alternarDenominacionFiltro =
            function (denominacion) {

                alternarValorFiltro(
                    $scope.filtrosTuneles.Denominacion,
                    denominacion,
                    false
                );
            };


        /* ==========================================
           GRAVEDAD
           ========================================== */

        $scope.gravedadFiltroSeleccionada =
            function (gravedad) {

                return valorFiltroSeleccionado(
                    $scope.filtrosTuneles.Gravedad,
                    gravedad,
                    false
                );
            };


        $scope.alternarGravedadFiltro =
            function (gravedad) {

                alternarValorFiltro(
                    $scope.filtrosTuneles.Gravedad,
                    gravedad,
                    false
                );
            };


        $scope.gistunelesCargar = function () {

            $scope.pestanyamenusuperior = 'gistuneles';

            $timeout(function () {

                if (!$scope.map) {
                    inicializarMapaTunelesADIF();
                }

                if (!$scope.map) {
                    return;
                }

                google.maps.event.trigger(
                    $scope.map,
                    'resize'
                );

                mostrarCapaViasADIF(false);

                cargarCapaTunelesADIF();

            }, 200);
        };


        $scope.viasadifCargar = function () {

            $scope.pestanyamenusuperior = 'viasadif';

            $timeout(function () {

                /*
                 * Crear el mapa si todavía no existe.
                 */
                if (!$scope.map) {
                    inicializarMapaTunelesADIF();
                }

                if (!$scope.map) {

                    console.error(
                        'No se ha podido inicializar el mapa de Vías ADIF'
                    );

                    return;
                }

                /*
                 * El div acaba de hacerse visible mediante ng-show.
                 */
                google.maps.event.trigger(
                    $scope.map,
                    'resize'
                );

                cargarCapaViasADIF();
                cargarCapaTunelesADIF();


            }, 200);
        };


        $scope.analisisGlobalCargar = function () {

            $scope.pestanyamenusuperior = 'analisisglobal';

            mostrarCapaViasADIF(false);

            actualizarIndicadoresAnalisisGlobal();

            $timeout(
                function () {
                    actualizarGraficoAnalisisGravedad();
                    programarActualizacionGraficoAnalisisTipos();
                    programarActualizacionGraficoAnalisisElementos();
                },
                100
            );
        };


        function actualizarIndicadoresAnalisisGlobal() {

            var listaTuneles =
                $scope.tunelesFiltrados || [];

            var numeroTuneles =
                listaTuneles.length;


            var gravedadesSeleccionadas =
                (
                    $scope.filtrosTuneles &&
                    angular.isArray(
                        $scope.filtrosTuneles.Gravedad
                    )
                )
                    ? $scope.filtrosTuneles.Gravedad
                    : [];


            var usarTodas =
                gravedadesSeleccionadas.length === 0;


            var seleccionarN1 = usarTodas;
            var seleccionarN2 = usarTodas;
            var seleccionarN3 = usarTodas;
            var seleccionarN4 = usarTodas;


            angular.forEach(
                gravedadesSeleccionadas,
                function (gravedad) {

                    var valor =
                        normalizarTexto(gravedad);


                    if (valor === 'leve') {

                        seleccionarN1 = true;

                    } else if (valor === 'moderado') {

                        seleccionarN2 = true;

                    } else if (valor === 'severo') {

                        seleccionarN3 = true;

                    } else if (valor === 'critico') {

                        seleccionarN4 = true;
                    }
                }
            );


            var tunelesConDanos = 0;

            var totalDanosSeleccionados = 0;

            var totalN1 = 0;
            var totalN2 = 0;
            var totalN3 = 0;
            var totalN4 = 0;

            var longitudTotalMetros = 0;

            $scope.colorIndicadorGravedad = function () {

                var indicadores =
                    $scope.indicadoresAnalisisGlobal || {};

                if (
                    indicadores.MostrarN4 &&
                    Number(indicadores.N4) > 0
                ) {
                    return '#FF0000';
                }

                if (
                    indicadores.MostrarN3 &&
                    Number(indicadores.N3) > 0
                ) {
                    return '#FF8C00';
                }

                if (
                    indicadores.MostrarN2 &&
                    Number(indicadores.N2) > 0
                ) {
                    return '#B59A00';
                }

                if (
                    indicadores.MostrarN1 &&
                    Number(indicadores.N1) > 0
                ) {
                    return '#008000';
                }

                return '#777777';
            };

            angular.forEach(
                listaTuneles,
                function (tunel) {

                    var danos =
                        tunel.DaniosPorGravedad || {};


                    var n1 =
                        Number(danos.Leve) || 0;

                    var n2 =
                        Number(danos.Moderado) || 0;

                    var n3 =
                        Number(danos.Severo) || 0;

                    var n4 =
                        Number(danos.Critico) || 0;


                    totalN1 += n1;
                    totalN2 += n2;
                    totalN3 += n3;
                    totalN4 += n4;


                    var danosTunelSeleccionados = 0;


                    if (seleccionarN1) {
                        danosTunelSeleccionados += n1;
                    }

                    if (seleccionarN2) {
                        danosTunelSeleccionados += n2;
                    }

                    if (seleccionarN3) {
                        danosTunelSeleccionados += n3;
                    }

                    if (seleccionarN4) {
                        danosTunelSeleccionados += n4;
                    }


                    totalDanosSeleccionados +=
                        danosTunelSeleccionados;


                    if (danosTunelSeleccionados > 0) {

                        tunelesConDanos++;
                    }


                    var longitud =
                        Number(
                            String(
                                tunel.Longitud || 0
                            ).replace(',', '.')
                        );


                    if (!isNaN(longitud)) {

                        longitudTotalMetros += longitud;
                    }

                }
            );


            var longitudKm =
                longitudTotalMetros > 0
                    ? longitudTotalMetros / 1000
                    : 0;


            var danosPorKm =
                longitudKm > 0
                    ? totalDanosSeleccionados /
                    longitudKm
                    : 0;


            var porcentajeTunelesConDanos =
                numeroTuneles > 0
                    ? (
                        tunelesConDanos /
                        numeroTuneles
                    ) * 100
                    : 0;


            var etiquetas = [];


            if (seleccionarN1) {
                etiquetas.push('N1');
            }

            if (seleccionarN2) {
                etiquetas.push('N2');
            }

            if (seleccionarN3) {
                etiquetas.push('N3');
            }

            if (seleccionarN4) {
                etiquetas.push('N4');
            }


            var textoGravedades =
                etiquetas.join(' + ');


            $scope.indicadoresAnalisisGlobal = {
                NumeroTuneles: numeroTuneles,
                TunelesConDanos: tunelesConDanos,
                PorcentajeTunelesConDanos: porcentajeTunelesConDanos,
                TotalDanos: totalDanosSeleccionados,
                N1: totalN1,
                N2: totalN2,
                N3: totalN3,
                N4: totalN4,
                LongitudKm: longitudKm,
                DanosPorKm: danosPorKm,
                TextoGravedades: textoGravedades,
                MostrarN1: seleccionarN1,
                MostrarN2: seleccionarN2,
                MostrarN3: seleccionarN3,
                MostrarN4: seleccionarN4,
                VariacionPorcentaje: 0,
                VariacionAbsoluta: 0
            };
        }

        function construirTooltipTunel(feature) {

            return ''
                + '<div style="line-height:1.45; max-width:300px;">'
                + '<strong>'
                + escaparHtml(
                    feature.getProperty('Denominacion') ||
                    'Túnel ADIF'
                )
                + '</strong>'
                + '<div><b>Línea:</b> '
                + escaparHtml(feature.getProperty('LineaDescripcion'))
                + '</div>'
                + '<div><b>Gravedad:</b> '
                + escaparHtml(feature.getProperty('GravedadTunel'))
                + '</div>'
                + '<div><b>Leves:</b> '
                + escaparHtml(feature.getProperty('DaniosLeves') || 0)
                + '</div>'
                + '<div><b>Moderados:</b> '
                + escaparHtml(feature.getProperty('DaniosModerados') || 0)
                + '</div>'
                + '<div><b>Severos:</b> '
                + escaparHtml(feature.getProperty('DaniosSeveros') || 0)
                + '</div>'
                + '<div><b>Críticos:</b> '
                + escaparHtml(feature.getProperty('DaniosCriticos') || 0)
                + '</div>'
                + '</div>';
        }


        $scope.etiquetaGravedadFiltro = function (gravedad) {
            switch (normalizarTexto(gravedad)) {
                case 'leve':
                    return 'N1';

                case 'moderado':
                    return 'N2';

                case 'severo':
                    return 'N3';

                case 'critico':
                case 'crítico':
                    return 'N4';

                default:
                    return 'Sin determinar';
            }
        };

        $scope.filtrosTuneles = {
            TipoRedId: [],
            Jefatura: [],
            IdElemInventario: [],
            Denominacion: [],
            Gravedad: []
        };

        /*
         * Textos utilizados solamente para buscar
         * dentro de cada bocadillo.
         */

        $scope.buscarTipoRedFiltro = '';
        $scope.buscarJefaturaFiltro = '';
        $scope.buscarTunelFiltro = '';
        $scope.buscarDenominacionFiltro = '';
        $scope.buscarGravedadFiltro = '';

        $scope.formatearNumero = function (
            numero,
            decimales
        ) {

            if (
                numero === null ||
                numero === undefined ||
                numero === ''
            ) {
                return '0';
            }

            var valor = Number(numero);

            if (isNaN(valor)) {
                return numero;
            }

            var decimalesInformados =
                decimales !== null &&
                decimales !== undefined &&
                decimales !== '';


            var numeroDecimales =
                decimalesInformados
                    ? Number(decimales)
                    : (
                        Math.trunc(valor) === valor
                            ? 0
                            : 1
                    );


            if (
                !isFinite(numeroDecimales) ||
                numeroDecimales < 0
            ) {

                numeroDecimales = 0;
            }


            numeroDecimales =
                Math.min(
                    20,
                    Math.trunc(numeroDecimales)
                );


            var partes =
                valor
                    .toFixed(numeroDecimales)
                    .split('.');


            var parteEntera =
                partes[0].replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    '.'
                );


            if (numeroDecimales === 0) {

                return parteEntera;
            }


            return (
                parteEntera +
                ',' +
                partes[1]
            );
        };

        infraestructurasService.getGravedades()
            .then(function (response) {

                var datos = angular.isArray(response.data)
                    ? response.data
                    : [];

                var encontrados = {};

                $scope.catalogoGravedades = datos
                    .map(function (gravedad) {

                        if (angular.isString(gravedad)) {
                            return gravedad.trim();
                        }

                        return String(
                            gravedad.Descripcion ||
                            gravedad.descripcion ||
                            ''
                        ).trim();

                    })
                    .filter(function (descripcion) {

                        var clave =
                            descripcion.toLowerCase();

                        if (
                            !descripcion ||
                            encontrados[clave]
                        ) {
                            return false;
                        }

                        encontrados[clave] = true;

                        return true;
                    });


                if (
                    $scope.catalogoGravedades
                        .indexOf('Sin determinar') === -1
                ) {
                    $scope.catalogoGravedades.push(
                        'Sin determinar'
                    );
                }


                $scope.gravedadesDisponibles =
                    angular.copy(
                        $scope.catalogoGravedades
                    );


                actualizarOpcionesFiltrosAsociados();

            })
            .catch(function (error) {

                console.error(
                    'Error cargando las gravedades:',
                    error
                );

                $scope.catalogoGravedades = [
                    'Sin determinar'
                ];

                $scope.gravedadesDisponibles = [
                    'Sin determinar'
                ];
            });



        $scope.ordenColumna = 'NivelGravedad';

        $scope.ordenInverso = true;

        $scope.ordenarTunelesPorGravedad = function () {
            $scope.ordenInverso = !$scope.ordenInverso;

            recalcularListadoTuneles();
        };

        $scope.limpiarFiltrosTuneles = function () {

            $scope.filtrosTuneles = {

                TipoRedId: [],

                Jefatura: [],

                IdElemInventario: [],

                Denominacion: [],

                Gravedad: []

            };


            $scope.buscarTipoRedFiltro = '';

            $scope.buscarJefaturaFiltro = '';

            $scope.buscarTunelFiltro = '';

            $scope.buscarDenominacionFiltro = '';

            $scope.buscarGravedadFiltro = '';


            if ($scope.map) {

                $scope.map.setCenter(
                    new google.maps.LatLng(
                        40.20,
                        -3.70
                    )
                );

                $scope.map.setZoom(6);
            }
        };

        $scope.tunelFiltroSeleccionado = function (idElemInventario) {

            return (
                $scope.filtrosTuneles.IdElemInventario
                    .indexOf(idElemInventario) !== -1
            );
        };


        $scope.alternarTunelFiltro =
            function (idElemInventario) {

                alternarValorFiltro(
                    $scope.filtrosTuneles.IdElemInventario,
                    idElemInventario,
                    false
                );
            };


        $scope.jefaturasDisponibles = [];
        $scope.ideleminventarioDisponibles = [];
        $scope.denominacionesDisponibles = [];
        $scope.gravedadesDisponibles = [];
        $scope.tiposRedDisponibles = [];


        function obtenerValoresUnicos(lista, propiedad) {
            var resultado = [];

            angular.forEach(lista || [], function (elemento) {
                var valor = elemento[propiedad];

                if (
                    valor !== null &&
                    valor !== undefined &&
                    String(valor).trim() !== '' &&
                    resultado.indexOf(valor) === -1
                ) {
                    resultado.push(valor);
                }
            });

            resultado.sort(function (a, b) {
                return String(a).localeCompare(
                    String(b),
                    'es',
                    {
                        numeric: true,
                        sensitivity: 'base'
                    }
                );
            });

            return resultado;
        }

        function actualizarOpcionesFiltrosAsociados() {

            var tuneles =
                $scope.tunelesADIF || [];


            /*
             * JEFATURAS
             */
            var tunelesParaJefatura =
                tuneles.filter(function (tunel) {

                    return cumpleFiltrosTunel(
                        tunel,
                        'Jefatura'
                    );
                });

            $scope.jefaturasDisponibles =
                obtenerValoresUnicos(
                    tunelesParaJefatura,
                    'Jefatura'
                );


            /*
             * TÚNELES
             */
            var tunelesParaInventario =
                tuneles.filter(function (tunel) {

                    return cumpleFiltrosTunel(
                        tunel,
                        'IdElemInventario'
                    );
                });

            $scope.ideleminventarioDisponibles =
                obtenerValoresUnicos(
                    tunelesParaInventario,
                    'IdElemInventario'
                );


            /*
             * DENOMINACIONES
             */
            var tunelesParaDenominacion =
                tuneles.filter(function (tunel) {

                    return cumpleFiltrosTunel(
                        tunel,
                        'Denominacion'
                    );
                });

            $scope.denominacionesDisponibles =
                obtenerValoresUnicos(
                    tunelesParaDenominacion,
                    'Denominacion'
                );


            /*
             * TIPOS DE RED
             */
            var tunelesParaTipoRed =
                tuneles.filter(function (tunel) {

                    return cumpleFiltrosTunel(
                        tunel,
                        'TipoRedId'
                    );
                });

            var idsTipoRedDisponibles = {};

            angular.forEach(
                tunelesParaTipoRed,
                function (tunel) {

                    if (
                        tunel.TipoRedId !== null &&
                        tunel.TipoRedId !== undefined
                    ) {
                        idsTipoRedDisponibles[
                            Number(tunel.TipoRedId)
                        ] = true;
                    }
                }
            );


            $scope.tiposRedDisponibles =
                ($scope.catalogoTiposRed || [])
                    .filter(function (tipoRed) {

                        return !!idsTipoRedDisponibles[
                            Number(tipoRed.Id)
                        ];
                    });


            /*
             * GRAVEDADES
             */
            var tunelesParaGravedad =
                tuneles.filter(function (tunel) {

                    return cumpleFiltrosTunel(
                        tunel,
                        'Gravedad'
                    );
                });


            var gravedadesEncontradas = {};
            var existeSinDeterminar = false;


            angular.forEach(
                tunelesParaGravedad,
                function (tunel) {

                    var nivel =
                        Number(tunel.NivelGravedad) || 0;

                    if (nivel === 0) {

                        existeSinDeterminar = true;

                        return;
                    }


                    var gravedad =
                        String(
                            tunel.GravedadTunel || ''
                        ).trim();

                    if (gravedad) {

                        gravedadesEncontradas[
                            normalizarTexto(gravedad)
                        ] = true;
                    }
                }
            );


            $scope.gravedadesDisponibles =
                ($scope.catalogoGravedades || [])
                    .filter(function (gravedad) {

                        if (
                            normalizarTexto(gravedad) ===
                            'sin determinar'
                        ) {
                            return false;
                        }

                        return !!gravedadesEncontradas[
                            normalizarTexto(gravedad)
                        ];
                    });


            if (existeSinDeterminar) {

                $scope.gravedadesDisponibles.push(
                    'Sin determinar'
                );
            }
        }

        function cumpleFiltrosTunel(tunel, filtroIgnorado) {

            if (!tunel) {
                return false;
            }


            var filtros =
                $scope.filtrosTuneles || {};


            var jefaturas =
                angular.isArray(filtros.Jefatura)
                    ? filtros.Jefatura
                    : [];


            var tunelesSeleccionados =
                angular.isArray(
                    filtros.IdElemInventario
                )
                    ? filtros.IdElemInventario
                    : [];


            var denominaciones =
                angular.isArray(
                    filtros.Denominacion
                )
                    ? filtros.Denominacion
                    : [];


            var tiposRed =
                angular.isArray(
                    filtros.TipoRedId
                )
                    ? filtros.TipoRedId
                    : [];


            var gravedades =
                angular.isArray(
                    filtros.Gravedad
                )
                    ? filtros.Gravedad
                    : [];


            var jefatura =
                normalizarTexto(
                    tunel.Jefatura
                );


            var idElemInventario =
                normalizarTexto(
                    tunel.IdElemInventario
                );


            var denominacion =
                normalizarTexto(
                    tunel.Denominacion
                );


            var gravedadTunel =
                normalizarTexto(
                    tunel.GravedadTunel
                );


            var colorGravedad =
                normalizarTexto(
                    tunel.ColorGravedad
                );


            var nivelGravedad =
                Number(
                    tunel.NivelGravedad
                ) || 0;



            /*
             * JEFATURA
             */

            var cumpleJefatura =
                filtroIgnorado === 'Jefatura' ||
                jefaturas.length === 0 ||
                jefaturas.some(
                    function (valor) {

                        return (
                            normalizarTexto(valor) ===
                            jefatura
                        );
                    }
                );



            /*
             * TÚNEL
             */

            var cumpleTunel =
                filtroIgnorado ===
                'IdElemInventario' ||

                tunelesSeleccionados.length === 0 ||

                tunelesSeleccionados.some(
                    function (valor) {

                        return (
                            normalizarTexto(valor) ===
                            idElemInventario
                        );
                    }
                );



            /*
             * DENOMINACIÓN
             */

            var cumpleDenominacion =
                filtroIgnorado ===
                'Denominacion' ||

                denominaciones.length === 0 ||

                denominaciones.some(
                    function (valor) {

                        return (
                            normalizarTexto(valor) ===
                            denominacion
                        );
                    }
                );



            /*
             * TIPO RED
             */

            var cumpleTipoRed =
                filtroIgnorado ===
                'TipoRedId' ||

                tiposRed.length === 0 ||

                tiposRed.some(
                    function (id) {

                        return (
                            Number(id) ===
                            Number(tunel.TipoRedId)
                        );
                    }
                );



            /*
             * GRAVEDAD
             */

            var cumpleGravedad =
                filtroIgnorado ===
                'Gravedad' ||

                gravedades.length === 0 ||

                gravedades.some(
                    function (valor) {

                        var gravedad =
                            normalizarTexto(valor);


                        if (
                            gravedad ===
                            'sin determinar'
                        ) {

                            return (
                                nivelGravedad === 0 ||
                                !colorGravedad ||
                                colorGravedad ===
                                '#9e9e9e'
                            );
                        }


                        return (
                            gravedadTunel ===
                            gravedad
                        );
                    }
                );


            return (
                cumpleJefatura &&
                cumpleTunel &&
                cumpleDenominacion &&
                cumpleTipoRed &&
                cumpleGravedad
            );
        }


        $scope.filtrarTuneles = function (tunel) {

            return cumpleFiltrosTunel(
                tunel,
                null
            );
        };




        $scope.marcadoresTunelesADIF = [];

        var URL_CAPA_TUNELES_ADIF =
            'app/data/tuneles_adif.json';

        var URL_CAPA_VIAS_ADIF =
            'app/data/vias_adif.json';

        var capaTunelesADIF = null;
        var capaTunelesADIFCargando = false;
        var capaTunelesADIFCargada = false;
        var ventanaInformacionTunelADIF = null;

        var capaViasADIF = null;
        var capaViasADIFCargando = false;
        var capaViasADIFCargada = false;
        var ventanaInformacionViaADIF = null;


        var indiceTunelesPorId = {};


        function mostrarCapaTunelesADIF(mostrar) {

            if (capaTunelesADIF) {
                capaTunelesADIF.setMap(
                    mostrar ? $scope.map : null
                );
            }

            if (!mostrar && ventanaInformacionTunelADIF) {
                ventanaInformacionTunelADIF.close();
            }
        }


        function construirInformacionTunelGeoJson(feature) {

            var linea =
                feature.getProperty('Línea Desc') ||
                'Línea no disponible';

            return ''
                + '<div style="max-width: 320px; line-height: 1.45;">'
                + '<strong>Túnel ADIF</strong>'
                + '<div><b>Línea:</b> '
                + escaparHtml(linea)
                + '</div>'
                + '</div>';
        }



        function escaparHtml(valor) {

            return String(
                valor === null || valor === undefined
                    ? ''
                    : valor
            )
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }


        function valorPropiedadVia(feature, nombre) {

            return escaparHtml(
                feature.getProperty(nombre)
            );
        }


        function construirInformacionVia(feature) {

            return ''
                + '<div style="max-width: 360px; line-height: 1.45;">'
                + '<strong>'
                + (valorPropiedadVia(feature, 'NOMBRE') || 'Vía ADIF')
                + '</strong>'
                + '<div><b>ID:</b> ' + valorPropiedadVia(feature, 'ID') + '</div>'
                + '<div><b>Identificación:</b> ' + valorPropiedadVia(feature, 'IDENTIFICA') + '</div>'
                + '<div><b>Estado:</b> ' + valorPropiedadVia(feature, 'ESTADO') + '</div>'
                + '<div><b>ID inventario:</b> ' + valorPropiedadVia(feature, 'IDINVENTAR') + '</div>'
                + '<div><b>PK inicial:</b> ' + valorPropiedadVia(feature, 'PK_OFICIAL') + '</div>'
                + '<div><b>PK final:</b> ' + valorPropiedadVia(feature, 'PK_OFICI_1') + '</div>'
                + '<div><b>Ancho:</b> ' + valorPropiedadVia(feature, 'ANCHO') + '</div>'
                + '<div><b>Fecha de baja:</b> ' + valorPropiedadVia(feature, 'FECHA_BAJA') + '</div>'
                + '</div>';
        }


        function cargarCapaViasADIF() {

            console.log(
                'Entrando en cargarCapaViasADIF'
            );

            console.log(
                'Mapa:',
                $scope.map
            );

            console.log(
                'URL GeoJSON:',
                URL_CAPA_VIAS_ADIF
            );

            if (
                !$scope.map ||
                capaViasADIFCargando
            ) {
                return;
            }

            if (capaViasADIFCargada) {
                mostrarCapaViasADIF(true);
                return;
            }

            capaViasADIFCargando = true;

            $http.get(URL_CAPA_VIAS_ADIF, {
                cache: true
            })
                .then(function (response) {

                    capaViasADIF =
                        new google.maps.Data({
                            map:
                                $scope.pestanyamenusuperior === 'viasadif'
                                    ? $scope.map
                                    : null
                        });

                    var elementos =
                        capaViasADIF.addGeoJson(
                            response.data
                        );

                    capaViasADIF.setStyle(
                        function (feature) {

                            var estado = normalizarTexto(
                                feature.getProperty('ESTADO')
                            );

                            var color = '#1565c0';

                            if (estado.indexOf('proyect') !== -1) {
                                color = '#ef6c00';
                            } else if (estado.indexOf('baja') !== -1) {
                                color = '#757575';
                            }

                            return {
                                strokeColor: color,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                clickable: true
                            };
                        }
                    );

                    ventanaInformacionViaADIF =
                        new google.maps.InfoWindow();

                    capaViasADIF.addListener(
                        'click',
                        function (evento) {

                            ventanaInformacionViaADIF.setContent(
                                construirInformacionVia(
                                    evento.feature
                                )
                            );

                            ventanaInformacionViaADIF.setPosition(
                                evento.latLng
                            );

                            ventanaInformacionViaADIF.open(
                                $scope.map
                            );
                        }
                    );

                    capaViasADIFCargada = true;

                    console.log(
                        'Capa de vías ADIF cargada:',
                        elementos.length,
                        'elementos'
                    );
                })
                .catch(function (error) {

                    console.error(
                        'No se pudo cargar la capa de vías ADIF:',
                        error
                    );
                })
                .finally(function () {

                    capaViasADIFCargando = false;
                });
        }

        function obtenerIdDetalleTunel(feature) {

            /*
             * El primer campo válido debe ser el ID numérico utilizado
             * actualmente por:
             *
             * /infraestructura/tunelADIF/{id}
             *
             * Cuando se pueda inspeccionar el fichero conviene dejar
             * aquí solamente su nombre real.
             */
            var candidatos = [
                'Id',
                'ID',
                'id',
                'IdTunel',
                'ID_TUNEL',
                'OBJECTID'
            ];

            for (var i = 0; i < candidatos.length; i++) {

                var valor =
                    feature.getProperty(candidatos[i]);

                if (
                    valor !== null &&
                    valor !== undefined &&
                    valor !== ''
                ) {
                    return valor;
                }
            }

            return null;
        }


        function obtenerTunelLista(feature) {

            return indiceTunelesPorId[
                Number(feature.getProperty('Id'))
            ] || null;
        }


        function actualizarVisibilidadTunelesADIF() {

            if (!capaTunelesADIF) {
                return;
            }

            capaTunelesADIF.forEach(function (feature) {

                var tunel =
                    obtenerTunelLista(feature);

                feature.setProperty(
                    '_visible',
                    tunel
                        ? $scope.filtrarTuneles(tunel)
                        : false
                );
            });
        }

        function cargarCapaTunelesADIF() {

            if (!angular.isArray($scope.tunelesADIF)) {

                $timeout(cargarCapaTunelesADIF, 100);

                return;
            }

            if (
                !$scope.map ||
                capaTunelesADIFCargando
            ) {
                return;
            }

            if (capaTunelesADIFCargada) {

                mostrarCapaTunelesADIF(true);
                actualizarVisibilidadTunelesADIF();

                return;
            }

            /*
             * Índice rápido: Id del GeoJSON -> túnel de la lista.
             */
            indiceTunelesPorId = {};

            angular.forEach(
                $scope.tunelesADIF,
                function (tunel) {

                    indiceTunelesPorId[
                        Number(tunel.Id)
                    ] = tunel;
                }
            );

            capaTunelesADIFCargando = true;

            $http.get(URL_CAPA_TUNELES_ADIF, {
                cache: true
            })
                .then(function (response) {

                    capaTunelesADIF =
                        new google.maps.Data({
                            map:
                                $scope.pestanyamenusuperior ===
                                    'viasadif'
                                    ? $scope.map
                                    : null
                        });

                    var elementos =
                        capaTunelesADIF.addGeoJson(
                            response.data
                        );

                    var tooltipTunelesADIF =
                        new google.maps.InfoWindow({
                            disableAutoPan: true
                        });

                    capaTunelesADIF.setStyle(
                        function (feature) {

                            if (
                                feature.getProperty('_visible') ===
                                false
                            ) {
                                return {
                                    visible: false
                                };
                            }

                            var tunel =
                                obtenerTunelLista(feature);

                            return {
                                visible: true,

                                icon: {
                                    path:
                                        google.maps.SymbolPath.CIRCLE,
                                    scale: 7,
                                    fillColor:
                                        tunel &&
                                            tunel.ColorGravedad
                                            ? tunel.ColorGravedad
                                            : '#9e9e9e',
                                    fillOpacity: 1,
                                    strokeColor: '#ffffff',
                                    strokeWeight: 2
                                },

                                clickable: true
                            };
                        }
                    );

                    capaTunelesADIF.addListener(
                        'mouseover',
                        function (evento) {

                            var tunel =
                                obtenerTunelLista(
                                    evento.feature
                                );

                            if (!tunel) {
                                return;
                            }

                            tooltipTunelesADIF.setContent(
                                construirTooltipDanios(tunel)
                            );

                            tooltipTunelesADIF.setPosition(
                                evento.latLng
                            );

                            tooltipTunelesADIF.open(
                                $scope.map
                            );
                        }
                    );

                    capaTunelesADIF.addListener(
                        'mouseout',
                        function () {
                            tooltipTunelesADIF.close();
                        }
                    );

                    capaTunelesADIF.addListener(
                        'click',
                        function (evento) {

                            var tunel =
                                obtenerTunelLista(
                                    evento.feature
                                );

                            if (!tunel || !tunel.Id) {
                                return;
                            }

                            $scope.$applyAsync(function () {
                                $scope.verTunelADIF(tunel.Id);
                            });
                        }
                    );

                    capaTunelesADIFCargada = true;

                    /*
                     * Sin filtros muestra los 1.882.
                     * Con filtros muestra solamente los que
                     * devuelve filtrarTuneles().
                     */
                    actualizarVisibilidadTunelesADIF();

                    console.log(
                        'Capa de túneles cargada:',
                        elementos.length,
                        'elementos'
                    );
                })
                .catch(function (error) {

                    console.error(
                        'No se pudo cargar la capa de túneles ADIF:',
                        error
                    );
                })
                .finally(function () {
                    capaTunelesADIFCargando = false;
                });
        }


        function mostrarCapaViasADIF(mostrar) {

            if (!capaViasADIF) {
                return;
            }

            capaViasADIF.setMap(
                mostrar ? $scope.map : null
            );

            if (!mostrar && ventanaInformacionViaADIF) {
                ventanaInformacionViaADIF.close();
            }
        }


        function limpiarMarcadoresTunelesADIF() {

            angular.forEach(
                $scope.marcadoresTunelesADIF,
                function (marker) {
                    marker.setMap(null);
                }
            );

            $scope.marcadoresTunelesADIF = [];
        }


        function construirTooltipDanios(tunelADIF) {

            var danos =
                tunelADIF.DaniosPorGravedad || {};

            var leves = Number(danos.Leve) || 0;
            var moderados = Number(danos.Moderado) || 0;
            var severos = Number(danos.Severo) || 0;
            var criticos = Number(danos.Critico) || 0;

            return ''
                + '<div style="'
                + 'background-color: #000000;'
                + 'color: #ffffff;'
                + 'padding: 9px 10px;'
                + 'border-radius: 5px;'
                + 'font-size: 16px;'
                + 'line-height: 20px;'
                + 'white-space: nowrap;'
                + 'box-shadow: 0 2px 8px rgba(0,0,0,0.35);'
                + '">'

                + '<div style="'
                + 'font-weight: bold;'
                + 'color: #ffffff;'
                + 'margin-bottom: 2px;'
                + '">'
                + 'Patologías:'
                + '</div>'

                + '<div style="color: #00c853;">'
                + 'Leve: ' + leves
                + '</div>'

                + '<div style="color: #ffd600;">'
                + 'Moderado: ' + moderados
                + '</div>'

                + '<div style="color: #ff8c00;">'
                + 'Severo: ' + severos
                + '</div>'

                + '<div style="color: #ff0000;">'
                + 'Crítico: ' + criticos
                + '</div>'

                + '</div>';
        }


        function convertirCoordenada(valor) {

            if (
                valor === null ||
                valor === undefined ||
                String(valor).trim() === ''
            ) {
                return NaN;
            }

            return Number(
                String(valor)
                    .trim()
                    .replace(',', '.')
            );
        }


        function coordenadasValidas(latitud, longitud) {

            return (
                isFinite(latitud) &&
                isFinite(longitud) &&
                latitud >= -90 &&
                latitud <= 90 &&
                longitud >= -180 &&
                longitud <= 180
            );
        }


        function obtenerPosicionTunel(tunelADIF) {

            /*
             * Intentar primero con las coordenadas de entrada.
             */
            var latitudEntrada = convertirCoordenada(
                tunelADIF.LatitudEntradaETRS89
            );

            var longitudEntrada = convertirCoordenada(
                tunelADIF.LongitudEntradaETRS89
            );

            if (
                coordenadasValidas(
                    latitudEntrada,
                    longitudEntrada
                )
            ) {
                return new google.maps.LatLng(
                    latitudEntrada,
                    longitudEntrada
                );
            }

            /*
             * Si no existen coordenadas válidas de entrada,
             * utilizar las coordenadas de salida.
             */
            var latitudSalida = convertirCoordenada(
                tunelADIF.LatitudSalidaETRS89
            );

            var longitudSalida = convertirCoordenada(
                tunelADIF.LongitudSalidaETRS89
            );

            if (
                coordenadasValidas(
                    latitudSalida,
                    longitudSalida
                )
            ) {
                return new google.maps.LatLng(
                    latitudSalida,
                    longitudSalida
                );
            }

            return null;
        }



        function actualizarMarcadoresTunelesADIF() {

            if (!$scope.map || !$scope.tunelesADIF) {
                return;
            }

            limpiarMarcadoresTunelesADIF();

            if (!$scope.tooltipDaniosGIS) {

                $scope.tooltipDaniosGIS =
                    new google.maps.InfoWindow({
                        disableAutoPan: true,
                        pixelOffset:
                            new google.maps.Size(0, -8)
                    });
            }

            var tunelesFiltrados =
                $scope.tunelesADIF.filter(
                    function (tunelADIF) {
                        return $scope.filtrarTuneles(
                            tunelADIF
                        );
                    }
                );

            var limites =
                new google.maps.LatLngBounds();

            var numeroMarcadores = 0;
            var unicaPosicion = null;
            var tunelesSinCoordenadas = [];


            var hayFiltros =

                (
                    angular.isArray(
                        $scope.filtrosTuneles.TipoRedId
                    ) &&
                    $scope.filtrosTuneles.TipoRedId.length > 0
                )

                ||

                (
                    angular.isArray(
                        $scope.filtrosTuneles.Jefatura
                    ) &&
                    $scope.filtrosTuneles.Jefatura.length > 0
                )

                ||

                (
                    angular.isArray(
                        $scope.filtrosTuneles.IdElemInventario
                    ) &&
                    $scope.filtrosTuneles.IdElemInventario.length > 0
                )

                ||

                (
                    angular.isArray(
                        $scope.filtrosTuneles.Denominacion
                    ) &&
                    $scope.filtrosTuneles.Denominacion.length > 0
                )

                ||

                (
                    angular.isArray(
                        $scope.filtrosTuneles.Gravedad
                    ) &&
                    $scope.filtrosTuneles.Gravedad.length > 0
                );

            angular.forEach(
                tunelesFiltrados,
                function (tunelADIF) {

                    var posicion =
                        obtenerPosicionTunel(tunelADIF);

                    if (!posicion) {

                        tunelesSinCoordenadas.push({
                            Id: tunelADIF.Id,
                            Denominacion:
                                tunelADIF.Denominacion,
                            LatitudEntrada:
                                tunelADIF.LatitudEntradaETRS89,
                            LongitudEntrada:
                                tunelADIF.LongitudEntradaETRS89,
                            LatitudSalida:
                                tunelADIF.LatitudSalidaETRS89,
                            LongitudSalida:
                                tunelADIF.LongitudSalidaETRS89
                        });

                        return;
                    }

                    var marker =
                        new google.maps.Marker({

                            position: posicion,

                            /*
                             * Se mantiene el título para poder
                             * identificar el túnel.
                             */
                            title:
                                (
                                    tunelADIF.Denominacion ||
                                    'Túnel sin denominación'
                                ) +
                                ' - Gravedad: ' +
                                (
                                    tunelADIF.GravedadTunel ||
                                    'Sin inspección'
                                ),

                            draggable: false,

                            icon: {
                                path:
                                    google.maps.SymbolPath.CIRCLE,

                                scale: 9,

                                fillColor:
                                    tunelADIF.ColorGravedad ||
                                    '#9e9e9e',

                                fillOpacity: 1,

                                strokeColor: '#ffffff',
                                strokeOpacity: 1,
                                strokeWeight: 2
                            },

                            map: $scope.map
                        });

                    var contenidoTooltip =
                        construirTooltipDanios(
                            tunelADIF
                        );

                    marker.addListener(
                        'mouseover',
                        function () {

                            $scope.tooltipDaniosGIS
                                .setContent(
                                    contenidoTooltip
                                );

                            $scope.tooltipDaniosGIS.open(
                                $scope.map,
                                marker
                            );
                        }
                    );

                    marker.addListener(
                        'mouseout',
                        function () {

                            $scope.tooltipDaniosGIS.close();
                        }
                    );

                    marker.addListener(
                        'click',
                        function () {

                            $scope.$applyAsync(function () {

                                $scope.verTunelADIF(
                                    tunelADIF.Id
                                );

                            });

                        }
                    );

                    $scope.marcadoresTunelesADIF.push(
                        marker
                    );

                    limites.extend(posicion);
                    unicaPosicion = posicion;
                    numeroMarcadores++;
                }
            );

            /*
             * Ajustar el mapa una sola vez,
             * después de crear todos los marcadores.
             */
            if (hayFiltros && numeroMarcadores === 1) {

                $scope.map.setCenter(
                    unicaPosicion
                );

                $scope.map.setZoom(15);

            } else if (
                hayFiltros &&
                numeroMarcadores > 1
            ) {

                $scope.map.fitBounds(
                    limites
                );

            } else if (!hayFiltros) {

                /*
                 * Vista inicial de España.
                 */
                $scope.map.setCenter(
                    new google.maps.LatLng(
                        40.20,
                        -3.70
                    )
                );

                $scope.map.setZoom(6);
            }

            /*
             * Mostrar en consola los túneles que realmente
             * no pueden representarse.
             */
            if (tunelesSinCoordenadas.length > 0) {

                console.warn(
                    'Túneles ADIF sin coordenadas ETRS89 válidas:',
                    tunelesSinCoordenadas
                );
            }

            console.log(
                'Túneles recibidos:',
                $scope.tunelesADIF.length,
                'Túneles filtrados:',
                tunelesFiltrados.length,
                'Marcadores creados:',
                numeroMarcadores
            );
        }


        function filtrosMultiplesHanCambiado(
            nuevoValor,
            valorAnterior
        ) {

            if (nuevoValor === valorAnterior) {
                return;
            }


            recalcularListadoTuneles();

            actualizarOpcionesFiltrosAsociados();

            actualizarVisibilidadTunelesADIF();

            /*
             * Actualizar gráfico si estamos
             * en Análisis Global.
             */

            if (
                $scope.pestanyamenusuperior ===
                'analisisglobal'
            ) {
                $timeout(
                    function () {
                        actualizarGraficoAnalisisGravedad();
                        programarActualizacionGraficoAnalisisTipos();
                        programarActualizacionGraficoAnalisisElementos();
                    },
                    50
                );
            }

        }


        $scope.$watchCollection(
            'filtrosTuneles.TipoRedId',
            filtrosMultiplesHanCambiado
        );


        $scope.$watchCollection(
            'filtrosTuneles.Jefatura',
            filtrosMultiplesHanCambiado
        );


        $scope.$watchCollection(
            'filtrosTuneles.IdElemInventario',
            filtrosMultiplesHanCambiado
        );


        $scope.$watchCollection(
            'filtrosTuneles.Denominacion',
            filtrosMultiplesHanCambiado
        );


        $scope.$watchCollection(
            'filtrosTuneles.Gravedad',
            filtrosMultiplesHanCambiado
        );


        function inicializarMapaTunelesADIF() {

            if ($scope.map) {
                return $scope.map;
            }

            var mapDiv = document.getElementById("map_canvas");

            if (!mapDiv) {
                console.error("No existe el elemento #map_canvas");
                return null;
            }

            var centroInicial = new google.maps.LatLng(
                40.20,
                -3.70
            );

            $scope.map = new google.maps.Map(mapDiv, {
                zoom: 6,
                center: centroInicial,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            return $scope.map;
        }


        $timeout(function () {

            inicializarMapaTunelesADIF();

        }, 0);

        $scope.catalogoTiposRed = [];
        $scope.tiposRedDisponibles = [];

        infraestructurasService.getTiposRed()
            .then(function (response) {
                $scope.catalogoTiposRed = response.data || [];
                actualizarOpcionesFiltrosAsociados();
            })
            .catch(function (error) {
                console.error(
                    'Error cargando tipos de red:',
                    error
                );
                $scope.catalogoTiposRed = [];
                $scope.tiposRedDisponibles = [];
            });


        infraestructurasService.getInfraestructurasADIFCategoria($rootScope.categoria, $rootScope.usuario)
            .then(function (response) {
                var data = response.data;
                $scope.tunelesADIF =
                    angular.isArray(data)
                        ? data
                        : [];

                recalcularListadoTuneles();

                actualizarOpcionesFiltrosAsociados();

                if ($scope.tunelesADIF.length > 0) {
                    $scope.IdElemInventario = $scope.tunelesADIF[0].IdElemInventario;
                    $scope.Gerencia = $scope.tunelesADIF[0].Gerencia;
                    $scope.Jefatura = $scope.tunelesADIF[0].Jefatura;
                    $scope.Via = $scope.tunelesADIF[0].Via;
                    $scope.PkInicial = $scope.tunelesADIF[0].PkInicial;
                    $scope.PkFinal = $scope.tunelesADIF[0].PkFinal;
                    $scope.LineaCodigo = $scope.tunelesADIF[0].LineaCodigo;
                    $scope.LineaEje = $scope.tunelesADIF[0].LineaEje;
                    $scope.LineaDescripcion = $scope.tunelesADIF[0].LineaDescripcion;
                    $scope.NumTunel = $scope.tunelesADIF[0].NumTunel;
                    $scope.Denominacion = $scope.tunelesADIF[0].Denominacion;
                    $scope.LatitudEntradaETRS89 = $scope.tunelesADIF[0].LatitudEntradaETRS89;
                    $scope.LatitudSalidaETRS89 = $scope.tunelesADIF[0].LatitudSalidaETRS89;
                    $scope.LongitudEntradaETRS89 = $scope.tunelesADIF[0].LongitudEntradaETRS89;
                    $scope.LongitudSalidaETRS89 = $scope.tunelesADIF[0].LongitudSalidaETRS89;
                    $scope.EstadoElemInventario = $scope.tunelesADIF[0].EstadoElemInventario;
                    $scope.Longitud = $scope.tunelesADIF[0].Longitud;
                    $scope.NumLineas = $scope.tunelesADIF[0].NumLineas;
                    $scope.NumVias = $scope.tunelesADIF[0].NumVias;
                    $scope.CoordenadaXEntrada = $scope.tunelesADIF[0].CoordenadaXEntrada;
                    $scope.CoordenadaYEntrada = $scope.tunelesADIF[0].CoordenadaYEntrada;
                    $scope.CoordenadaXSalida = $scope.tunelesADIF[0].CoordenadaXSalida;
                    $scope.CoordenadaYSalida = $scope.tunelesADIF[0].CoordenadaYSalida;
                    $scope.IdInventario = $scope.tunelesADIF[0].IdInventario;
                    $scope.CodTrayecto = $scope.tunelesADIF[0].CodTrayecto;
                    $scope.Trayecto = $scope.tunelesADIF[0].Trayecto;
                    $scope.TrayectoPkIni = $scope.tunelesADIF[0].TrayectoPkIni;
                    $scope.TrayectoPkFin = $scope.tunelesADIF[0].TrayectoPkFin;

                }

                $scope.pestanyamenusuperior === 'viasadif'
                    ? $scope.map
                    : null


            })
            .catch(function (error) {

                console.error(
                    'Error cargando túneles ADIF:',
                    error
                );

            })
            .finally(function () {

                document.body.classList.remove(
                    'cargando-tuneles-adif'
                );

            });


        $scope.verTunelADIF = function (idTunelADIF) {
            inspeccionesService
                .getInspeccionesTunelADIF(
                    idTunelADIF
                )
                .then(function (response) {
                    var inspecciones =
                        response.data || [];
                    if (inspecciones.length === 0) {
                        alert(
                            'Este túnel no tiene inspecciones registradas.'
                        );
                    }

                    $location.path('/infraestructura/tunelADIF/' + idTunelADIF);
                })
                .catch(function (error) {
                    console.error('Error comprobando las inspecciones del túnel:', error);
                    $location.path('/infraestructura/tunelADIF/' + idTunelADIF);
                });
        };


        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

        var myOptions = {
            zoom: 14,
            center: myLatlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };


        $scope.irTunelADIF = function (CoordenadaXEntrada, CoordenadaYEntrada) {

            myLatlng = new google.maps.LatLng(CoordenadaYEntrada, CoordenadaXEntrada);

            $scope.map.panTo(myLatlng);
        };


        $scope.tamanoPagina = 100;
        $scope.paginaActual = 1;

        $scope.tunelesFiltrados = [];
        $scope.tunelesPagina = [];


        function actualizarPaginaTuneles() {

            var inicio =
                ($scope.paginaActual - 1) *
                $scope.tamanoPagina;

            $scope.tunelesPagina =
                $scope.tunelesFiltrados.slice(
                    inicio,
                    inicio + $scope.tamanoPagina
                );
        }


        function recalcularListadoTuneles() {

            var lista = ($scope.tunelesADIF || [])
                .filter(function (tunel) {
                    return $scope.filtrarTuneles(tunel);
                });

            lista.sort(function (a, b) {

                var nivelA =
                    Number(a.NivelGravedad) || 0;

                var nivelB =
                    Number(b.NivelGravedad) || 0;

                if ($scope.ordenInverso) {
                    return nivelB - nivelA;
                }

                return nivelA - nivelB;
            });

            $scope.tunelesFiltrados = lista;

            calcularResumenTuneles($scope.tunelesFiltrados);

            actualizarIndicadoresAnalisisGlobal();

            $scope.paginaActual = 1;

            actualizarPaginaTuneles();
        }

        function calcularResumenTuneles(tuneles) {

            var resumen = {
                NumeroTuneles: 0,
                TotalPatologias: 0,

                Leves: 0,
                Moderadas: 0,
                Severas: 0,
                Criticas: 0,

                TunelesSinDeterminar: 0,
                TunelesConPatologias: 0
            };

            angular.forEach(tuneles || [], function (tunel) {

                resumen.NumeroTuneles++;

                var danos =
                    tunel.DaniosPorGravedad || {};

                var leves =
                    Number(danos.Leve) || 0;

                var moderadas =
                    Number(danos.Moderado) || 0;

                var severas =
                    Number(danos.Severo) || 0;

                var criticas =
                    Number(danos.Critico) || 0;


                resumen.Leves += leves;
                resumen.Moderadas += moderadas;
                resumen.Severas += severas;
                resumen.Criticas += criticas;


                var totalTunel =
                    leves +
                    moderadas +
                    severas +
                    criticas;

                resumen.TotalPatologias +=
                    totalTunel;


                if (totalTunel > 0) {
                    resumen.TunelesConPatologias++;
                }


                if (
                    Number(tunel.NivelGravedad) === 0
                ) {
                    resumen.TunelesSinDeterminar++;
                }

            });


            $scope.resumenTuneles =
                resumen;
        }


        $scope.paginaAnterior = function () {

            if ($scope.paginaActual > 1) {
                $scope.paginaActual--;
                actualizarPaginaTuneles();
            }
        };


        $scope.paginaSiguiente = function () {

            var totalPaginas =
                Math.ceil(
                    $scope.tunelesFiltrados.length /
                    $scope.tamanoPagina
                );

            if ($scope.paginaActual < totalPaginas) {
                $scope.paginaActual++;
                actualizarPaginaTuneles();
            }
        };


        $scope.numeroPaginas = function () {

            if (
                !$scope.tunelesFiltrados ||
                $scope.tunelesFiltrados.length === 0
            ) {
                return 1;
            }

            return Math.ceil(
                $scope.tunelesFiltrados.length /
                $scope.tamanoPagina
            );
        };


        $scope.patologiasSeleccionadas = [];
        $scope.gravedadPatologiasSeleccionada = null;
        $scope.cargandoPatologias = false;
        $scope.mostrarModalPatologias = false;

        $scope.cerrarModalPatologias = function () {
            $scope.mostrarModalPatologias = false;
        };

        $scope.verPatologia = function (dano) {

            if (!dano ||
                !dano.Id ||
                !dano.InspeccionId) {

                console.error(
                    'No se puede abrir la patología:',
                    dano
                );

                return;
            }


            // -----------------------------------------------------
            // GUARDAR QUE VENIMOS DEL MODAL DE PATOLOGÍAS
            // -----------------------------------------------------

            $rootScope.damageDesdeModalPatologias = true;


            // Guardamos el estado actual del modal
            $rootScope.estadoModalPatologias = {

                gravedad:
                    $scope.gravedadPatologiasSeleccionada,

                pagina:
                    $scope.paginaPatologias,

                filtrosTuneles:
                    angular.copy($scope.filtrosTuneles),

                pestanya:
                    $scope.pestanyamenusuperior
            };


            // Cerrar modal
            $scope.mostrarModalPatologias = false;


            // Ir al DAMAGE.HTML
            $location.path(
                '/damagesADIF/' +
                dano.InspeccionId +
                '/' +
                dano.Id
            );
        };

        function cargarPaginaPatologias() {

            var idsTuneles =
                ($scope.tunelesFiltrados || [])
                    .map(function (tunel) {
                        return tunel.Id;
                    });

            if (idsTuneles.length === 0) {
                return;
            }

            // ---------------------------------------------
            // MOSTRAR RELOJ EN EL CURSOR
            // ---------------------------------------------
            document.body.classList.add(
                'cargando-tuneles-adif'
            );

            $scope.cargandoPatologias = true;

            infraestructurasService.getPatologiasTunelesADIF(idsTuneles, $scope.gravedadPatologiasSeleccionada, $scope.paginaPatologias, $scope.tamanoPaginaPatologias)
                .then(function (response) {

                    var resultado = response.data || {};
                    $scope.patologiasSeleccionadas = resultado.Datos || [];
                    $scope.totalPatologiasModal = resultado.Total || 0;
                    $scope.totalPaginasPatologias =
                        Math.max(
                            1,
                            Math.ceil(
                                $scope.totalPatologiasModal /
                                $scope.tamanoPaginaPatologias
                            )
                        );

                })
                .catch(function (error) {
                    console.error(
                        'Error cargando patologías',
                        error
                    );
                    $scope.patologiasSeleccionadas = [];
                })
                .finally(function () {
                    $scope.cargandoPatologias = false;
                    // ---------------------------------------------
                    // QUITAR RELOJ
                    // ---------------------------------------------
                    document.body.classList.remove(
                        'cargando-tuneles-adif'
                    );
                });
        }

        $scope.abrirPatologias = function (gravedad) {

            $scope.gravedadPatologiasSeleccionada = gravedad;
            $scope.paginaPatologias = 1;
            $scope.patologiasSeleccionadas = [];
            $scope.mostrarModalPatologias = true;
            cargarPaginaPatologias();
        };

        $scope.paginaAnteriorPatologias = function () {

            if ($scope.paginaPatologias > 1) {
                $scope.paginaPatologias--;
                cargarPaginaPatologias();
            }
        };


        $scope.paginaSiguientePatologias = function () {

            if ($scope.paginaPatologias < $scope.totalPaginasPatologias) {
                $scope.paginaPatologias++;
                cargarPaginaPatologias();
            }
        };


        $scope.exportarTunelesExcel = function () {

            if (!$scope.tunelesFiltrados || $scope.tunelesFiltrados.length === 0) {
                return;
            }

            var idsTuneles =
                $scope.tunelesFiltrados
                    .map(function (tunel) {
                        return tunel.Id;
                    });

            document.body.classList.add(
                'cargando-tuneles-adif'
            );


            infraestructurasService
                .exportarTunelesADIF(
                    idsTuneles,
                    $rootScope.usuario
                )
                .then(function (response) {

                    var blob =
                        new Blob(
                            [response.data],
                            {
                                type:
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            }
                        );


                    var url =
                        window.URL
                            .createObjectURL(
                                blob
                            );


                    var enlace = document.createElement('a');

                    enlace.href = url;
                    var hoy = new Date();

                    var fecha = hoy.getFullYear() + '-' + String(hoy.getMonth() + 1).padStart(2, '0') + '-' + String(hoy.getDate()).padStart(2, '0');

                    enlace.download = 'Tuneles_ADIF_' + fecha + '.xlsx';
                    document.body.appendChild(enlace);
                    enlace.click();
                    document.body.removeChild(enlace);
                    window.URL.revokeObjectURL(url);
                })
                .catch(function (error) {
                    console.error('Error exportando túneles a Excel:', error);
                    alert('No se ha podido generar el Excel.');
                })
                .finally(function () {
                    document.body.classList.remove('cargando-tuneles-adif');
                });
        };


        var chartJsCargando = false;
        var callbacksChartJs = [];


        function cargarChartJs(callback) {

            if (typeof window.Chart !== 'undefined') {

                callback();

                return;
            }


            callbacksChartJs.push(callback);


            if (chartJsCargando) {
                return;
            }


            chartJsCargando = true;


            var urlsChartJs = [
                'https://cdn.jsdelivr.net/npm/chart.js@4.4.7/dist/chart.umd.min.js',
                'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.7/chart.umd.min.js'
            ];


            function finalizarCargaChartJs() {

                chartJsCargando = false;

                var callbacks =
                    callbacksChartJs.slice();

                callbacksChartJs = [];


                $timeout(
                    function () {

                        angular.forEach(
                            callbacks,
                            function (funcion) {

                                funcion();
                            }
                        );

                    },
                    0
                );
            }


            function intentarCargar(indice) {

                if (indice >= urlsChartJs.length) {

                    chartJsCargando = false;
                    callbacksChartJs = [];

                    console.error(
                        'No se ha podido cargar Chart.js.'
                    );

                    return;
                }


                var script =
                    document.createElement('script');

                script.src = urlsChartJs[indice];
                script.async = true;


                script.onload = function () {

                    if (
                        typeof window.Chart ===
                        'undefined'
                    ) {

                        intentarCargar(indice + 1);

                        return;
                    }


                    finalizarCargaChartJs();
                };


                script.onerror = function () {

                    intentarCargar(indice + 1);
                };


                document.head.appendChild(script);
            }


            intentarCargar(0);
        }


        var graficoAnalisisGravedad = null;
        var graficoAnalisisTipos = null;
        var temporizadorGraficoAnalisisTipos = null;
        var numeroSolicitudGraficoAnalisisTipos = 0;
        var graficoAnalisisElementos = null;
        var temporizadorGraficoAnalisisElementos = null;
        var numeroSolicitudGraficoAnalisisElementos = 0;


        $scope.estadoGraficoAnalisisTipos = {
            Cargando: false,
            Error: false,
            HayDatos: false,
            TotalDanos: 0,
            TotalTipos: 0
        };


        $scope.estadoGraficoAnalisisElementos = {
            Cargando: false,
            Error: false,
            HayDatos: false,
            TotalDanos: 0,
            TotalElementos: 0
        };


        function actualizarGraficoAnalisisGravedad() {

            if (typeof window.Chart === 'undefined') {

                cargarChartJs(
                    function () {

                        actualizarGraficoAnalisisGravedad();
                    }
                );

                return;
            }


            var canvas =
                document.getElementById(
                    'graficoAnalisisGravedad'
                );


            if (!canvas) {

                return;
            }


            var tuneles =
                $scope.tunelesFiltrados || [];


            var conN4 = 0;
            var conN3 = 0;
            var conN2 = 0;
            var conN1 = 0;
            var sinGravedadInformada = 0;


            angular.forEach(
                tuneles,
                function (tunel) {

                    /*
                     * Clasificar cada túnel por su nivel
                     * global de gravedad, no por el número
                     * de patologías de cada nivel.
                     */

                    var nivel =
                        Number(tunel.NivelGravedad) || 0;


                    /*
                     * Respaldo para registros que no tengan
                     * NivelGravedad informado.
                     */
                    if (nivel === 0) {

                        var gravedad =
                            normalizarTexto(
                                tunel.GravedadTunel
                            );

                        if (gravedad === 'critico') {
                            nivel = 4;

                        } else if (gravedad === 'severo') {
                            nivel = 3;

                        } else if (gravedad === 'moderado') {
                            nivel = 2;

                        } else if (gravedad === 'leve') {
                            nivel = 1;
                        }
                    }


                    if (nivel === 4) {

                        conN4++;

                    } else if (nivel === 3) {

                        conN3++;

                    } else if (nivel === 2) {

                        conN2++;

                    } else if (nivel === 1) {

                        conN1++;

                    } else {

                        sinGravedadInformada++;
                    }
                }
            );


            var totalClasificados =
                conN4 +
                conN3 +
                conN2 +
                conN1;


            var totalTuneles =
                tuneles.length;


            var porcentajeClasificados =
                totalTuneles > 0
                    ? totalClasificados / totalTuneles * 100
                    : 0;


            var porcentajeSinGravedad =
                totalTuneles > 0
                    ? sinGravedadInformada / totalTuneles * 100
                    : 0;


            $scope.coberturaGravedadAnalisis = {

                TotalTuneles:
                    totalTuneles,

                TunelesClasificados:
                    totalClasificados,

                TunelesSinGravedad:
                    sinGravedadInformada,

                PorcentajeClasificados:
                    porcentajeClasificados,

                PorcentajeSinGravedad:
                    porcentajeSinGravedad
            };


            if (!$scope.$$phase) {

                $scope.$evalAsync();
            }


            /*
             * Destruir el gráfico anterior
             * antes de volver a pintarlo.
             */

            if (graficoAnalisisGravedad) {

                graficoAnalisisGravedad.destroy();

                graficoAnalisisGravedad = null;
            }


            var contexto =
                canvas.getContext('2d');


            graficoAnalisisGravedad =
                new window.Chart(
                    contexto,
                    {
                        type: 'doughnut',

                        data: {

                            labels: [
                                'N4',
                                'N3',
                                'N2',
                                'N1'
                            ],

                            datasets: [
                                {
                                    data: [
                                        conN4,
                                        conN3,
                                        conN2,
                                        conN1
                                    ],

                                    backgroundColor: [
                                        '#FF0000',
                                        '#FF8C00',
                                        '#FFD000',
                                        '#008000'
                                    ],

                                    borderColor: [
                                        '#FFFFFF',
                                        '#FFFFFF',
                                        '#FFFFFF',
                                        '#FFFFFF'
                                    ],

                                    borderWidth: 2
                                }
                            ]
                        },

                        options: {

                            responsive: true,

                            maintainAspectRatio: false,

                            cutout: '62%',

                            plugins: {

                                legend: {

                                    display: true,

                                    position: 'right',

                                    labels: {

                                        boxWidth: 12,

                                        padding: 12,

                                        color: '#153e7e',

                                        font: {
                                            size: 11
                                        },

                                        generateLabels:
                                            function (chart) {

                                                var datos =
                                                    chart.data.datasets[0].data;

                                                var total = 0;


                                                for (
                                                    var i = 0;
                                                    i < datos.length;
                                                    i++
                                                ) {

                                                    total +=
                                                        Number(datos[i]) || 0;
                                                }


                                                var etiquetas =
                                                    chart.data.labels;


                                                var colores =
                                                    chart.data.datasets[0]
                                                        .backgroundColor;


                                                return etiquetas.map(
                                                    function (
                                                        etiqueta,
                                                        indice
                                                    ) {

                                                        var cantidad =
                                                            Number(
                                                                datos[indice]
                                                            ) || 0;


                                                        var porcentaje =
                                                            total > 0
                                                                ? (
                                                                    cantidad /
                                                                    total *
                                                                    100
                                                                )
                                                                : 0;


                                                        return {

                                                            text:
                                                                etiqueta +
                                                                '   ' +
                                                                cantidad +
                                                                ' (' +
                                                                $scope
                                                                    .formatearNumero(
                                                                        porcentaje,
                                                                        0
                                                                    ) +
                                                                '%)',

                                                            fillStyle:
                                                                colores[indice],

                                                            strokeStyle:
                                                                colores[indice],

                                                            lineWidth: 0,

                                                            fontColor:
                                                                '#153e7e',

                                                            hidden: false,

                                                            index: indice
                                                        };
                                                    }
                                                );
                                            }
                                    }
                                },

                                tooltip: {

                                    callbacks: {

                                        label:
                                            function (context) {

                                                var datos =
                                                    context.dataset.data;

                                                var total = 0;


                                                for (
                                                    var i = 0;
                                                    i < datos.length;
                                                    i++
                                                ) {

                                                    total +=
                                                        Number(datos[i]) || 0;
                                                }


                                                var cantidad =
                                                    Number(
                                                        context.raw
                                                    ) || 0;


                                                var porcentaje =
                                                    total > 0
                                                        ? (
                                                            cantidad /
                                                            total *
                                                            100
                                                        )
                                                        : 0;


                                                return (
                                                    context.label +
                                                    ': ' +
                                                    cantidad +
                                                    ' túneles (' +
                                                    $scope.formatearNumero(
                                                        porcentaje,
                                                        1
                                                    ) +
                                                    '%)'
                                                );
                                            }
                                    }
                                }
                            }
                        },

                        plugins: [
                            {
                                id:
                                    'textoCentralGravedad',

                                afterDraw:
                                    function (chart) {

                                        if (!chart.chartArea) {

                                            return;
                                        }


                                        var contextoCentro =
                                            chart.ctx;


                                        var centroX =
                                            (
                                                chart.chartArea.left +
                                                chart.chartArea.right
                                            ) / 2;


                                        var centroY =
                                            (
                                                chart.chartArea.top +
                                                chart.chartArea.bottom
                                            ) / 2;


                                        contextoCentro.save();

                                        contextoCentro.textAlign =
                                            'center';

                                        contextoCentro.textBaseline =
                                            'middle';

                                        contextoCentro.fillStyle =
                                            '#153e7e';

                                        contextoCentro.font =
                                            'bold 22px Arial';

                                        contextoCentro.fillText(
                                            $scope.formatearNumero(
                                                totalClasificados,
                                                0
                                            ),
                                            centroX,
                                            centroY - 8
                                        );

                                        contextoCentro.fillStyle =
                                            '#153e7e';

                                        contextoCentro.font =
                                            '11px Arial';

                                        contextoCentro.fillText(
                                            'túneles',
                                            centroX,
                                            centroY + 13
                                        );

                                        contextoCentro.restore();
                                    }
                            }
                        ]
                    }
                );


            console.log(
                'Gráfico gravedad:',
                {
                    totalTuneles:
                        totalTuneles,

                    totalClasificados:
                        totalClasificados,

                    conN4:
                        conN4,

                    conN3:
                        conN3,

                    conN2:
                        conN2,

                    conN1:
                        conN1,

                    sinGravedadInformada:
                        sinGravedadInformada
                }
            );
        }


        function programarActualizacionGraficoAnalisisTipos() {

            if (temporizadorGraficoAnalisisTipos) {

                $timeout.cancel(
                    temporizadorGraficoAnalisisTipos
                );
            }


            temporizadorGraficoAnalisisTipos =
                $timeout(
                    function () {

                        temporizadorGraficoAnalisisTipos = null;

                        actualizarGraficoAnalisisTipos();
                    },
                    200
                );
        }


        function destruirGraficoAnalisisTipos() {

            if (graficoAnalisisTipos) {

                graficoAnalisisTipos.destroy();

                graficoAnalisisTipos = null;
            }
        }


        function actualizarGraficoAnalisisTipos() {

            if (typeof window.Chart === 'undefined') {

                cargarChartJs(
                    function () {

                        actualizarGraficoAnalisisTipos();
                    }
                );

                return;
            }


            var canvas =
                document.getElementById(
                    'graficoAnalisisTipos'
                );


            if (!canvas) {

                return;
            }


            var idsTuneles =
                ($scope.tunelesFiltrados || [])
                    .map(function (tunel) {

                        return Number(tunel.Id);
                    })
                    .filter(function (idTunel) {

                        return (
                            isFinite(idTunel) &&
                            idTunel > 0
                        );
                    });


            numeroSolicitudGraficoAnalisisTipos++;

            var numeroSolicitud =
                numeroSolicitudGraficoAnalisisTipos;


            if (idsTuneles.length === 0) {

                destruirGraficoAnalisisTipos();

                $scope.estadoGraficoAnalisisTipos = {
                    Cargando: false,
                    Error: false,
                    HayDatos: false,
                    TotalDanos: 0,
                    TotalTipos: 0
                };

                return;
            }


            $scope.estadoGraficoAnalisisTipos.Cargando = true;
            $scope.estadoGraficoAnalisisTipos.Error = false;


            infraestructurasService
                .getResumenTiposPatologiasTunelesADIF(
                    idsTuneles
                )
                .then(function (response) {

                    if (
                        numeroSolicitud !==
                        numeroSolicitudGraficoAnalisisTipos
                    ) {

                        return;
                    }


                    var filas =
                        angular.isArray(response.data)
                            ? response.data
                            : [];


                    var tipos =
                        filas
                            .map(function (fila) {

                                return {
                                    Tipo:
                                        String(
                                            fila.Tipo ||
                                            fila.tipo ||
                                            'Sin tipo informado'
                                        ),

                                    Total:
                                        Number(
                                            fila.Total !== undefined
                                                ? fila.Total
                                                : fila.total
                                        ) || 0
                                };
                            })
                            .filter(function (fila) {

                                return fila.Total > 0;
                            })
                            .sort(function (a, b) {

                                if (b.Total !== a.Total) {

                                    return b.Total - a.Total;
                                }


                                return a.Tipo.localeCompare(
                                    b.Tipo,
                                    'es'
                                );
                            });


                    var totalDanos =
                        tipos.reduce(
                            function (total, fila) {

                                return total + fila.Total;
                            },
                            0
                        );


                    var tiposPrincipales =
                        tipos.slice(0, 8);


                    if (tipos.length > 8) {

                        var totalOtros =
                            tipos
                                .slice(8)
                                .reduce(
                                    function (total, fila) {

                                        return total + fila.Total;
                                    },
                                    0
                                );


                        if (totalOtros > 0) {

                            tiposPrincipales.push({
                                Tipo: 'Otros',
                                Total: totalOtros
                            });
                        }
                    }


                    $scope.estadoGraficoAnalisisTipos = {
                        Cargando: false,
                        Error: false,
                        HayDatos: tiposPrincipales.length > 0,
                        TotalDanos: totalDanos,
                        TotalTipos: tipos.length
                    };


                    destruirGraficoAnalisisTipos();


                    if (tiposPrincipales.length === 0) {

                        return;
                    }


                    var etiquetas =
                        tiposPrincipales.map(
                            function (fila) {

                                return fila.Tipo;
                            }
                        );


                    var valores =
                        tiposPrincipales.map(
                            function (fila) {

                                return fila.Total;
                            }
                        );


                    graficoAnalisisTipos =
                        new window.Chart(
                            canvas.getContext('2d'),
                            {
                                type: 'bar',

                                data: {
                                    labels: etiquetas,

                                    datasets: [
                                        {
                                            data: valores,
                                            backgroundColor: '#153e7e',
                                            borderColor: '#0b2f63',
                                            borderWidth: 1,
                                            borderRadius: 3,
                                            barPercentage: 0.72,
                                            categoryPercentage: 0.86
                                        }
                                    ]
                                },

                                options: {
                                    indexAxis: 'y',
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    color: '#153e7e',

                                    font: {
                                        family: 'Arial'
                                    },

                                    layout: {
                                        padding: {
                                            right: 48
                                        }
                                    },

                                    plugins: {
                                        legend: {
                                            display: false
                                        },

                                        tooltip: {
                                            callbacks: {
                                                label:
                                                    function (context) {

                                                        var cantidad =
                                                            Number(
                                                                context.raw
                                                            ) || 0;


                                                        var porcentaje =
                                                            totalDanos > 0
                                                                ? cantidad /
                                                                totalDanos *
                                                                100
                                                                : 0;


                                                        return (
                                                            $scope
                                                                .formatearNumero(
                                                                    cantidad,
                                                                    0
                                                                ) +
                                                            ' daños (' +
                                                            $scope
                                                                .formatearNumero(
                                                                    porcentaje,
                                                                    1
                                                                ) +
                                                            '%)'
                                                        );
                                                    }
                                            }
                                        }
                                    },

                                    scales: {
                                        x: {
                                            beginAtZero: true,

                                            grid: {
                                                color: '#edf0f5',
                                                drawTicks: false
                                            },

                                            border: {
                                                display: false
                                            },

                                            ticks: {
                                                display: false,
                                                precision: 0,
                                                color: '#153e7e',
                                                font: {
                                                    size: 10
                                                }
                                            }
                                        },

                                        y: {
                                            grid: {
                                                display: false
                                            },

                                            ticks: {
                                                color: '#153e7e',
                                                font: {
                                                    size: 10
                                                },

                                                callback:
                                                    function (valor) {

                                                        var etiqueta =
                                                            this
                                                                .getLabelForValue(
                                                                    valor
                                                                );


                                                        return etiqueta.length > 24
                                                            ? etiqueta.substring(
                                                                0,
                                                                24
                                                            ) + '…'
                                                            : etiqueta;
                                                    }
                                            }
                                        }
                                    }
                                },

                                plugins: [
                                    {
                                        id:
                                            'valoresGraficoAnalisisTipos',

                                        afterDatasetsDraw:
                                            function (chart) {

                                                var contexto =
                                                    chart.ctx;


                                                var datos =
                                                    chart.data.datasets[0]
                                                        .data;


                                                var barras =
                                                    chart
                                                        .getDatasetMeta(0)
                                                        .data;


                                                contexto.save();
                                                contexto.fillStyle =
                                                    '#153e7e';
                                                contexto.font =
                                                    'bold 10px Arial';
                                                contexto.textAlign =
                                                    'left';
                                                contexto.textBaseline =
                                                    'middle';


                                                angular.forEach(
                                                    barras,
                                                    function (barra, indice) {

                                                        contexto.fillText(
                                                            $scope
                                                                .formatearNumero(
                                                                    datos[indice],
                                                                    0
                                                                ),
                                                            barra.x + 5,
                                                            barra.y
                                                        );
                                                    }
                                                );


                                                contexto.restore();
                                            }
                                    }
                                ]
                            }
                        );
                })
                .catch(function (error) {

                    if (
                        numeroSolicitud !==
                        numeroSolicitudGraficoAnalisisTipos
                    ) {

                        return;
                    }


                    destruirGraficoAnalisisTipos();

                    $scope.estadoGraficoAnalisisTipos = {
                        Cargando: false,
                        Error: true,
                        HayDatos: false,
                        TotalDanos: 0,
                        TotalTipos: 0
                    };


                    console.error(
                        'Error cargando el resumen de tipos de patologías:',
                        error
                    );
                });
        }


        function programarActualizacionGraficoAnalisisElementos() {

            if (temporizadorGraficoAnalisisElementos) {

                $timeout.cancel(
                    temporizadorGraficoAnalisisElementos
                );
            }


            temporizadorGraficoAnalisisElementos =
                $timeout(
                    function () {

                        temporizadorGraficoAnalisisElementos = null;

                        actualizarGraficoAnalisisElementos();
                    },
                    200
                );
        }


        function destruirGraficoAnalisisElementos() {

            if (graficoAnalisisElementos) {

                graficoAnalisisElementos.destroy();

                graficoAnalisisElementos = null;
            }
        }


        function actualizarGraficoAnalisisElementos() {

            if (typeof window.Chart === 'undefined') {

                cargarChartJs(
                    function () {

                        actualizarGraficoAnalisisElementos();
                    }
                );

                return;
            }


            var canvas =
                document.getElementById(
                    'graficoAnalisisElementos'
                );


            if (!canvas) {

                return;
            }


            var idsTuneles =
                ($scope.tunelesFiltrados || [])
                    .map(function (tunel) {

                        return Number(tunel.Id);
                    })
                    .filter(function (idTunel) {

                        return (
                            isFinite(idTunel) &&
                            idTunel > 0
                        );
                    });


            numeroSolicitudGraficoAnalisisElementos++;

            var numeroSolicitud =
                numeroSolicitudGraficoAnalisisElementos;


            if (idsTuneles.length === 0) {

                destruirGraficoAnalisisElementos();

                $scope.estadoGraficoAnalisisElementos = {
                    Cargando: false,
                    Error: false,
                    HayDatos: false,
                    TotalDanos: 0,
                    TotalElementos: 0
                };

                return;
            }


            $scope.estadoGraficoAnalisisElementos.Cargando = true;
            $scope.estadoGraficoAnalisisElementos.Error = false;


            infraestructurasService
                .getResumenElementosPatologiasTunelesADIF(
                    idsTuneles
                )
                .then(function (response) {

                    if (
                        numeroSolicitud !==
                        numeroSolicitudGraficoAnalisisElementos
                    ) {

                        return;
                    }


                    var filas =
                        angular.isArray(response.data)
                            ? response.data
                            : [];


                    var elementos =
                        filas
                            .map(function (fila) {

                                return {
                                    Elemento:
                                        String(
                                            fila.Elemento ||
                                            fila.elemento ||
                                            'Sin elemento informado'
                                        ),

                                    Total:
                                        Number(
                                            fila.Total !== undefined
                                                ? fila.Total
                                                : fila.total
                                        ) || 0
                                };
                            })
                            .filter(function (fila) {

                                return fila.Total > 0;
                            })
                            .sort(function (a, b) {

                                if (b.Total !== a.Total) {

                                    return b.Total - a.Total;
                                }


                                return a.Elemento.localeCompare(
                                    b.Elemento,
                                    'es'
                                );
                            });


                    var totalDanos =
                        elementos.reduce(
                            function (total, fila) {

                                return total + fila.Total;
                            },
                            0
                        );


                    var elementosPrincipales =
                        elementos.slice(0, 8);


                    if (elementos.length > 8) {

                        var totalOtros =
                            elementos
                                .slice(8)
                                .reduce(
                                    function (total, fila) {

                                        return total + fila.Total;
                                    },
                                    0
                                );


                        if (totalOtros > 0) {

                            elementosPrincipales.push({
                                Elemento: 'Otros',
                                Total: totalOtros
                            });
                        }
                    }


                    $scope.estadoGraficoAnalisisElementos = {
                        Cargando: false,
                        Error: false,
                        HayDatos: elementosPrincipales.length > 0,
                        TotalDanos: totalDanos,
                        TotalElementos: elementos.length
                    };


                    destruirGraficoAnalisisElementos();


                    if (elementosPrincipales.length === 0) {

                        return;
                    }


                    var etiquetas =
                        elementosPrincipales.map(
                            function (fila) {

                                return fila.Elemento;
                            }
                        );


                    var valores =
                        elementosPrincipales.map(
                            function (fila) {

                                return fila.Total;
                            }
                        );


                    graficoAnalisisElementos =
                        new window.Chart(
                            canvas.getContext('2d'),
                            {
                                type: 'bar',

                                data: {
                                    labels: etiquetas,

                                    datasets: [
                                        {
                                            data: valores,
                                            backgroundColor: '#153e7e',
                                            borderColor: '#0b2f63',
                                            borderWidth: 1,
                                            borderRadius: 3,
                                            barPercentage: 0.72,
                                            categoryPercentage: 0.86
                                        }
                                    ]
                                },

                                options: {
                                    indexAxis: 'y',
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    color: '#153e7e',

                                    font: {
                                        family: 'Arial'
                                    },

                                    layout: {
                                        padding: {
                                            right: 48
                                        }
                                    },

                                    plugins: {
                                        legend: {
                                            display: false
                                        },

                                        tooltip: {
                                            callbacks: {
                                                label:
                                                    function (context) {

                                                        var cantidad =
                                                            Number(
                                                                context.raw
                                                            ) || 0;


                                                        var porcentaje =
                                                            totalDanos > 0
                                                                ? cantidad /
                                                                totalDanos *
                                                                100
                                                                : 0;


                                                        return (
                                                            $scope
                                                                .formatearNumero(
                                                                    cantidad,
                                                                    0
                                                                ) +
                                                            ' daños (' +
                                                            $scope
                                                                .formatearNumero(
                                                                    porcentaje,
                                                                    1
                                                                ) +
                                                            '%)'
                                                        );
                                                    }
                                            }
                                        }
                                    },

                                    scales: {
                                        x: {
                                            beginAtZero: true,

                                            grid: {
                                                color: '#edf0f5',
                                                drawTicks: false
                                            },

                                            border: {
                                                display: false
                                            },

                                            ticks: {
                                                display: false,
                                                precision: 0,
                                                color: '#153e7e',
                                                font: {
                                                    size: 10
                                                }
                                            }
                                        },

                                        y: {
                                            grid: {
                                                display: false
                                            },

                                            ticks: {
                                                color: '#153e7e',
                                                font: {
                                                    size: 10
                                                },

                                                callback:
                                                    function (valor) {

                                                        var etiqueta =
                                                            this
                                                                .getLabelForValue(
                                                                    valor
                                                                );


                                                        return etiqueta.length > 24
                                                            ? etiqueta.substring(
                                                                0,
                                                                24
                                                            ) + '…'
                                                            : etiqueta;
                                                    }
                                            }
                                        }
                                    }
                                },

                                plugins: [
                                    {
                                        id:
                                            'valoresGraficoAnalisisElementos',

                                        afterDatasetsDraw:
                                            function (chart) {

                                                var contexto =
                                                    chart.ctx;


                                                var datos =
                                                    chart.data.datasets[0]
                                                        .data;


                                                var barras =
                                                    chart
                                                        .getDatasetMeta(0)
                                                        .data;


                                                contexto.save();
                                                contexto.fillStyle =
                                                    '#153e7e';
                                                contexto.font =
                                                    'bold 10px Arial';
                                                contexto.textAlign =
                                                    'left';
                                                contexto.textBaseline =
                                                    'middle';


                                                angular.forEach(
                                                    barras,
                                                    function (barra, indice) {

                                                        contexto.fillText(
                                                            $scope
                                                                .formatearNumero(
                                                                    datos[indice],
                                                                    0
                                                                ),
                                                            barra.x + 5,
                                                            barra.y
                                                        );
                                                    }
                                                );


                                                contexto.restore();
                                            }
                                    }
                                ]
                            }
                        );
                })
                .catch(function (error) {

                    if (
                        numeroSolicitud !==
                        numeroSolicitudGraficoAnalisisElementos
                    ) {

                        return;
                    }


                    destruirGraficoAnalisisElementos();

                    $scope.estadoGraficoAnalisisElementos = {
                        Cargando: false,
                        Error: true,
                        HayDatos: false,
                        TotalDanos: 0,
                        TotalElementos: 0
                    };


                    console.error(
                        'Error cargando el resumen de elementos afectados:',
                        error
                    );
                });
        }



        $scope.exportarPatologiasExcel = function () {

            var idsTuneles =
                ($scope.tunelesFiltrados || [])
                    .map(function (tunel) {
                        return tunel.Id;
                    });


            if (idsTuneles.length === 0) {
                return;
            }


            document.body.classList.add(
                'cargando-tuneles-adif'
            );


            infraestructurasService.exportarPatologiasTunelesADIF(idsTuneles, $scope.gravedadPatologiasSeleccionada)
                .then(function (response) {
                    var blob =
                        new Blob(
                            [response.data],
                            {
                                type:
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            }
                        );


                    var url = window.URL.createObjectURL(blob);
                    var enlace = document.createElement('a');
                    enlace.href = url;

                    /*
                     * Nombre del fichero.
                     */
                    var nombre = 'Patologias_ADIF';


                    if ($scope.gravedadPatologiasSeleccionada) {
                        nombre += '_' + $scope.gravedadPatologiasSeleccionada;
                    }

                    var fecha = new Date();

                    var fechaTexto = fecha.getFullYear() + '-' +
                        ('0' +
                            (fecha.getMonth() + 1)
                        ).slice(-2) +
                        '-' +
                        ('0' +
                            fecha.getDate()
                        ).slice(-2);


                    nombre += '_' + fechaTexto + '.xlsx';
                    enlace.download = nombre;
                    document.body.appendChild(enlace);
                    enlace.click();
                    document.body.removeChild(enlace);
                    window.URL.revokeObjectURL(url);
                })
                .catch(function (error) {
                    console.error('Error exportando patologías:', error);
                    alert('No se ha podido generar el Excel de patologías.');
                })
                .finally(function () {
                    document.body.classList.remove('cargando-tuneles-adif');
                });
        };


    }]);
